import classNames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmarkCircle } from '@fortawesome/pro-regular-svg-icons/faXmarkCircle';
import { faSearch } from '@fortawesome/pro-regular-svg-icons/faSearch';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const PremiumPublicationSearchFilter = ({ handleClearSearch, handleSearch, searchQuery }) => (
  <div className={cx('premiumPublicationSearchFilter')}>
    {searchQuery ? (
      <FontAwesomeIcon
        icon={faXmarkCircle}
        className={cx('cross')}
        onClick={handleClearSearch}
      />
    ) : (
      <FontAwesomeIcon
        icon={faSearch}
      />
    )}
    <input type="search" placeholder="Search" onChange={handleSearch} value={searchQuery} />
  </div>
);

export default PremiumPublicationSearchFilter;
